const fncls = 'fnparams-dede7cc5-15fd-4c75-a9f4-36c430ee3a99';

const typingSpeedConfig = (type) => ({
    type,
    fields: [
        { id: 'text-input-firstName', min: 5 },
        { id: 'text-input-lastName', min: 5 },
        { id: 'text-input-email', min: 7 },
        { id: 'text-input-password', min: 8 },
        { id: 'text-input-businessName', min: 3 },
        { id: 'text-input-bizEIN', min: 5 },
        { id: 'text-input-businessAddress.line1', min: 5 },
        { id: 'text-input-businessAddress.city', min: 5 },
        { id: 'text-input-businessAddress.postalCode', min: 3 },
        { id: 'text-input-businessWebsite', min: 5 },
        { id: 'text-input-businessPhoneNumber', min: 4 },
        { id: 'text-input-dob', min: 4 },
        { id: 'text-input-homeAddress.line1', min: 5 },
        { id: 'text-input-homeAddress.city', min: 5 },
        { id: 'text-input-homeAddress.postalCode', min: 3 },
        { id: 'text-input-personalPhoneNumber', min: 4 },
        { id: 'text-input-ssn', min: 4 }
    ],

    /*
     * Tell FraudNet to delegate event handling to the document body instead of trying to add event listeners to every field
     * This is necessary to handle dynamically rendered fields
     */
    delegate: true
});

function _injectConfig(options) {
    let script = document.getElementById('fconfig');

    if (script && script.parentNode) {
        script.parentNode.removeChild(script);
    }

    script = document.createElement('script');
    script.id = 'fconfig';
    script.type = 'application/json';
    script.setAttribute('fncls', fncls);

    let configuration = {
        f: options.sessionId,
        s: options.sourceId,
        mm: false,
        ts: typingSpeedConfig(options.sourceId)
    };

    script.text = JSON.stringify(configuration);
    document.body.appendChild(script);
}

function _loadBeaconJS(options) {
    let script = document.createElement('script');
    script.src = options.url;
    document.body.appendChild(script);
}

export default {
    trigger(options) {
        if (options) {
            _injectConfig(options);
            _loadBeaconJS(options);
        }
    }
};
